// React import
import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// Actions imports
import {hideNotification, showNotification} from "../../actions";
// Components imports
import ImageWithFallback from "../WalletTokensStatsItem/ImageWithFallback";
// Styles imports
import './WalletBalanceItem.css';
import '../../util.css'
// Svg icons import
import { ReactComponent as EthSvg } from '../../svg-icons/coins/eth.svg';
import { ReactComponent as BaseSvg } from '../../svg-icons/coins/base.svg';
import { ReactComponent as BnbSvg } from '../../svg-icons/coins/bnb.svg';
import { ReactComponent as TrendUpSvg } from '../../svg-icons/token-status/trend-up.svg';
import { ReactComponent as TrendDownSvg } from '../../svg-icons/token-status/trend-down.svg';
import { ReactComponent as TrendPumpSvg } from '../../svg-icons/token-status/trend-pump.svg';
import { ReactComponent as TrendDumpSvg } from '../../svg-icons/token-status/trend-dump.svg';
import { ReactComponent as TrendNoSvg } from '../../svg-icons/token-status/trend-no.svg';
import { ReactComponent as CopySvg } from '../../svg-icons/copy.svg';
// Consts imports
import {
    GREEN,
    EMERALD,
    YELLOW,
    ORANGE,
    RED,
    ETH_BLOCKCHAIN,
    ETH,
    BASE,
    BASE_BLOCKCHAIN,
    BSC, BSC_BLOCKCHAIN
} from "../../consts/consts";

async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
}

class Title extends React.Component {

    constructor(props) {
        super(props);
    }

    setNotification = () => {
        const { showNotification, hideNotification } = this.props;
        const duration = 750;

        showNotification({message: "Token address copied", duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    generateRandomKey = () => {
        const characters = '0123456789abcdef';
        let result = '';

        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }

        return result;
    }

    handleClick = async () => {
        const { address } = this.props;
        await copyTextToClipboard(address);
        this.setNotification();
    };

    render() {
        const {symbol, name, index, address, blockchain} = this.props;

        let tokenSymbol = symbol;
        let tokenName = name;

        if (tokenName.length > 12) {
            tokenName = tokenName.slice(0, 12) + '...';
        }

        if (tokenSymbol.length > 8) {
            tokenSymbol = tokenSymbol.slice(0, 8) + '...';
        }

        let blockchainName = ETH_BLOCKCHAIN;
        let fallbackComponent=(<EthSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        if (blockchain === ETH) {
            blockchainName = ETH_BLOCKCHAIN;
            fallbackComponent=(<EthSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        } else if (blockchain === BASE) {
            blockchainName = BASE_BLOCKCHAIN;
            fallbackComponent=(<BaseSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        } else if (blockchain === BSC) {
            blockchainName = BSC_BLOCKCHAIN;
            fallbackComponent=(<BnbSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        }
        blockchainName = blockchainName.toLowerCase();
        return (
            <div className={"check-wallet__balance-stats__token_title"}>
                <ImageWithFallback
                    fallbackSrc={"https://dd.dexscreener.com/ds-data/tokens/"+blockchainName+"/"+address+".png?size=md&key="+this.generateRandomKey()}
                    src={"https://www.dextools.io/resources/tokens/logos/"+blockchainName+"/"+address+".jpg?"+Date.now()}
                    tertiarySrc={"https://cdn.zerion.io/"+address+".png"}
                    fallbackComponent={fallbackComponent}
                    alt="Example Image"
                    className="check-wallet__token-stats-item__token-icon-png"
                />
                <div className={"check-wallet__balance-stats__title-description"}>
                    <span className={"check-wallet__balance-stats_index"}>
                        {index + 1}{"."}
                    </span>
                    <span className={"check-wallet__balance-stats_symbol"}>
                        {tokenSymbol}
                    </span>
                    <span className={"check-wallet__balance-stats_name"}>
                        {tokenName}
                    </span>
                    <div className={"check-wallet__balance-stats-item__copy-icon-block"} onClick={this.handleClick}>
                        <CopySvg className={"check-wallet__balance-stats-item__copy-icon"}/>
                    </div>
                </div>
            </div>
        );
    }

}
function Icon(props) {

    const { indicator } = props;

    let icon;

    if (indicator === GREEN) {
        icon = (<TrendPumpSvg className={"check-wallet__balance-stats__status-icon check-wallet__balance-stats-item__status-icon_green"}/>);
    } else if (indicator === EMERALD) {
        icon = (<TrendUpSvg className={"check-wallet__balance-stats__status-icon check-wallet__balance-stats-item__status-icon_emerald"}/>);
    } else if (indicator === YELLOW) {
        icon = (<TrendNoSvg className={"check-wallet__balance-stats__status-icon check-wallet__balance-stats-item__status-icon_yellow"}/>);
    } else if (indicator === ORANGE) {
        icon = (<TrendDownSvg className={"check-wallet__balance-stats__status-icon check-wallet__balance-stats-item__status-icon_orange"}/>);
    } else if (indicator === RED) {
        icon = (<TrendDumpSvg className={"check-wallet__balance-stats__status-icon check-wallet__balance-stats-item__status-icon_red"}/>);
    } else {
        return null
    }

    return (
        <div className={"check-wallet__balance-stats__icon-block"}>
            {icon}
        </div>
    )

}

function Stats(props) {

    const { balance, price, value, change } = props;

    return (
        <div className={"check-wallet__balance-stats"}>
            <span className={"check-wallet__balance-stats-text"}>
                Balance: {balance}<br/>Price: {price}
            </span>
            <span className={"check-wallet__balance-stats-text"}>
                Value: {value}<br/>Change (24h): {change}
            </span>
        </div>
    );

}

class WalletBalanceItem extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {

        const { symbol, name, indicator, balance,  price, value, change, index, address } = this.props;
        const { showNotification, hideNotification } = this.props;
        const { blockchain } = this.props.blockchain;

        return (
            <div className={"check-wallet__balance-stats__block"}>
                <Title symbol={symbol} name={name} index={index} address={address}
                       showNotification={showNotification} hideNotification={hideNotification}
                       blockchain={blockchain}/>
                <Stats balance={balance} price={price}
                       value={value} change={change}/>
                <Icon indicator={indicator}/>
            </div>
        );
    }

}
const mapStateToProps = ({checkWallet, notification, blockchain}) => {
    return {checkWallet, notification, blockchain};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showNotification: showNotification,
        hideNotification: hideNotification
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletBalanceItem);